import { Component, OnInit } from '@angular/core';
import { DelegationService } from './delegation.service';
declare var require : any;
var $ = require('jquery');

@Component({
  selector: 'app-delegation',
  templateUrl: './delegation.component.html',
  styleUrls: ['./delegation.component.css']
})
export class DelegationComponent implements OnInit {

  delegations = {
    delegators:[],
    delegates:[]
  };

  constructor(private delegationService : DelegationService) { 
  }

  ngOnInit() {
    this.loadDelegations();
  }

  loadDelegations(){
    this.delegationService.getDelegation().subscribe(
      (data) => {
        this.delegations = data;
        console.log(this.delegations);
      },
      (err) => {
        console.log(err);
      }
    );
  }
}